var _dec, _class, _Row;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component, Children, isValidElement } from 'react';
import { omitProps, safeCloneElement } from '@instructure/ui-react-utils';
import { View } from '@instructure/ui-view';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';
import TableContext from '../TableContext';

/**
---
parent: Table
id: Table.Row
---
**/
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
let Row = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_Row = class Row extends Component {
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props, {
      isStacked: this.context.isStacked,
      hover: this.context.hover
    });
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2, {
      isStacked: this.context.isStacked,
      hover: this.context.hover
    });
  }
  render() {
    const _this$props3 = this.props,
      children = _this$props3.children,
      styles = _this$props3.styles;
    const isStacked = this.context.isStacked;
    const headers = this.context.headers;
    return _jsx(View, {
      ...View.omitViewProps(omitProps(this.props, Row.allowedProps), Row),
      as: isStacked ? 'div' : 'tr',
      css: styles === null || styles === void 0 ? void 0 : styles.row,
      role: isStacked ? 'row' : void 0,
      children: Children.toArray(children).filter(Boolean).map((child, index) => {
        if (/*#__PURE__*/isValidElement(child)) {
          return safeCloneElement(child, {
            key: child.props.name,
            // Sent down for compatibility with custom components
            // TODO DEPRECATED, remove in v11
            isStacked,
            // used by `Cell` to render its column title in `stacked` layout
            header: headers && headers[index]
          });
        }
        return child;
      })
    });
  }
}, _Row.displayName = "Row", _Row.componentId = 'Table.Row', _Row.contextType = TableContext, _Row.allowedProps = allowedProps, _Row.propTypes = propTypes, _Row.defaultProps = {
  children: null
}, _Row)) || _class);
export default Row;
export { Row };